module.exports = __webpack_public_path__ + "img/chat.c573b1a1.svg";